let active = null;
let sequence = 0;

function safelyStop(session, resetSource) {
  if (!session) return;
  session.cancel?.();
  const audio = session.audio;
  if (!audio) return;
  try { audio.pause(); } catch {}
  if (!resetSource) return;
  try { audio.removeAttribute?.("src"); } catch {}
  try { audio.load?.(); } catch {}
}

/** Coordinates ordinary beat previews across routes and components.
 * Deliberately exclude editors/mixers that require synchronized multitrack audio.
 */
export function claimOrdinaryAudio(owner, audio, {cancel, resetPreviousSource = false} = {}) {
  if (!owner || !audio) throw new Error("ordinary-audio-owner-required");
  if (active && (active.owner !== owner || active.audio !== audio)) safelyStop(active, resetPreviousSource);
  const token = ++sequence;
  active = {owner, audio, cancel, token};
  return token;
}

export function isOrdinaryAudioCurrent(owner, audio, token) {
  return Boolean(active && active.owner === owner && active.audio === audio && active.token === token);
}

export function releaseOrdinaryAudio(owner, audio, {resetSource = false} = {}) {
  if (!active || active.owner !== owner || active.audio !== audio) return false;
  const previous = active; active = null; safelyStop(previous, resetSource); return true;
}

export function ordinaryAudioOnPlay(owner) {
  return (event) => claimOrdinaryAudio(owner, event.currentTarget);
}

export function resetOrdinaryAudioForTests() {
  if (active) safelyStop(active, false);
  active = null; sequence = 0;
}
